import {
    alert,
    magazineArticle,
    magazineArticleList,
    magazineBtn, magazineFooterBtn,
    magazineForm,
    magazineFormTag, magazineRequestList,
    popupMagazineAuthorItem,
    popupMagazineJoin,
    popupMagazineJoinItem,
    popupMagazineRequestItem, popupUserList
} from '../loaders';
import { setWindowTemplates } from '../Templates';

(() => {
    setWindowTemplates('alert', alert);
    setWindowTemplates('magazine-form', magazineForm);
    setWindowTemplates('magazine-form-tag', magazineFormTag);
    setWindowTemplates('magazine-btn', magazineBtn);
    setWindowTemplates('magazine-article', magazineArticle);
    setWindowTemplates('magazine-article-list', magazineArticleList);
    setWindowTemplates('magazine-footer-btn', magazineFooterBtn);
    setWindowTemplates('magazine-request-list', magazineRequestList);
    setWindowTemplates('popup-magazine-author-item', popupMagazineAuthorItem);
    setWindowTemplates('popup-magazine-join', popupMagazineJoin);
    setWindowTemplates('popup-magazine-join-item', popupMagazineJoinItem);
    setWindowTemplates('popup-magazine-request-item', popupMagazineRequestItem);
    setWindowTemplates('popup-user-list', popupUserList);
})();
